import styled, { keyframes } from 'styled-components';

const ACCENT_TEAL = '#3a6767';
const TEXT_PRIMARY = '#040404';

const emailVerifiedToastIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(16px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

export const EmailVerifiedToastStyled = styled.div`
    position: fixed;
    top: max(16px, env(safe-area-inset-top, 0px));
    right: 16px;
    z-index: 1100;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    color: ${TEXT_PRIMARY};
    background: #fff;
    border: 1px solid #e8ecec;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    animation: ${emailVerifiedToastIn} 0.25s ease-out;
    max-width: min(360px, calc(100vw - 32px));

    p {
        margin: 0;
        color: ${TEXT_PRIMARY};
        font-family: 'Objektiv Mk2', sans-serif;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
    }

    @media (max-width: 550px) {
        right: 12px;
        padding: 8px 12px;

        p {
            font-size: 12px;
            line-height: 16px;
        }
    }
`;

export const EmailVerifiedCheckIcon = styled.svg.attrs({
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
})`
    flex-shrink: 0;
    display: block;

    circle {
        fill: ${ACCENT_TEAL};
    }

    path {
        stroke: #fff;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
`;
